"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
exports.getViewFromPath = (pathname) => {
    // No view pathname specified
    if (typeof pathname !== 'string') {
        return types_1.EMAIL_MAKER_DEFAULT_VIEW_ID;
    }
    // Remove any slashes
    pathname = pathname.replace(/\//g, '');
    // Paths should basically align with their viewIds, except sideBySide, which is the index
    return types_1.EMAIL_MAKER_VIEW_IDS.includes(pathname)
        ? pathname
        : types_1.EMAIL_MAKER_DEFAULT_VIEW_ID;
};
//# sourceMappingURL=getViewFromPath.js.map